import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { Service } from "src/common/models/service"
import { RootState } from "src/state/reducer"
import { GET_SERVICES_API } from "../state/actionTypes"
import { SystemDescriptions } from "src/common/descriptions"
import { useEffect } from "react"
import { clearCurrentService, getServicesApi } from "../state/action"
import useUserPermission from "src/hooks/useUserPermissions"
import { Urls } from "src/common/urls"
import { PageCard } from "src/common/styles/styles"
import { SearchableTable } from "src/components/SearchableTable"
import { ColumnsType } from "antd/es/table"
import { ColumnsKeys, TABLE_COLUMNS } from "./config"
import { Button, Space, Tooltip } from "antd"
import { EditOutlined, ProfileOutlined } from '@ant-design/icons'
import { searchableTableUtils } from "src/components/SearchableTable/utils"
import { USER_SCOPES } from "src/hooks/UserPermission"

export type ReduxProps = {
    services?: Service[],
    isGettingServices: boolean,
}

export const Services = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { validateUserScopeForPage } = useUserPermission()

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        services: state.service.services,
        isGettingServices: serviceLoading(state, [GET_SERVICES_API]),
    }))

    const descriptions = SystemDescriptions.PAGES.SERVICE.SERVICES
    const commonDescriptions = SystemDescriptions.PAGES.COMMON

    const { isUserAllowedToPerformAdminActions: userAdminActions } = useUserPermission()

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.SERVICE_READ)

        dispatch(getServicesApi())
        dispatch(clearCurrentService())
    }, [])

    const handleActionClick = () => {
        navigate(Urls.FRONTEND.SERVICE.CREATE)
    }

    const tblColumns: ColumnsType<Service> = [
        ...TABLE_COLUMNS,
        {
            title: descriptions.TABLE_COLUMNS.ACTIONS,
            dataIndex: ColumnsKeys.ACTIONS,
            key: ColumnsKeys.ACTIONS,
            align: searchableTableUtils.alignment.centerAlign,
            render: (_, record: Service) => {
                const handleEditClick = (serviceId: number) => {
                    navigate(Urls.FRONTEND.SERVICE.EDIT_PAGE(serviceId))
                }

                const handleViewClick = (customerId: number) => {
                    // navigate(Urls.FRONTEND.CUSTOMER.CUSTOMER_PROFILE_PAGE(customerId))
                }

                return <Space size="middle">
                    <Tooltip title={commonDescriptions.ACTIONS.VIEW} >
                        <Button type="primary" ghost shape="circle" size="small"
                            icon={<ProfileOutlined />}
                            onClick={() => handleViewClick(record.id!)}
                        />
                    </Tooltip>
                    {
                        userAdminActions
                            ?
                            <Tooltip title={commonDescriptions.ACTIONS.EDIT} >
                                <Button type="primary" ghost shape="circle" size="small"
                                    icon={<EditOutlined />}
                                    onClick={() => handleEditClick(record.id!)}
                                />
                            </Tooltip>
                            : null
                    }
                </Space>
            },
        },
    ]

    return (
        <PageCard
            size="small"
            title={descriptions.TITLE}
        >
            <SearchableTable
                showSearch
                showActionButton={userAdminActions}
                actionButtonLabel={descriptions.TABLE.ACTION_BUTTON}
                actionButtonOnClick={handleActionClick}
                showLoader={reduxProps.isGettingServices}
                items={reduxProps.services || []}
                tableColumns={tblColumns}
                searchLabel={descriptions.TABLE.SEARCH_PLACEHOLDER}
            />
        </PageCard>
    )
}
